var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMounted)?_c('section',{staticClass:"activities"},_vm._l((_vm.activities),function(activity,index){return _c('activity-card',{key:index,attrs:{"activity":activity,"open":""}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }